import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-input',
  templateUrl: './form-input.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent],
})
export class FormInputComponent extends FieldBaseComponent {}
